import { apiConfig } from '../api-config';

// eslint-disable-next-line no-shadow
export enum NotificationResponseType {
  None = 1,
  Pending = 2,
  Denied = 3,
  Granted = 4
}

export interface ResponseNotificationParams {
  notificationId: number;
  userId: number;
  notificationType: NotificationResponseType;
  tokenKey: string;
}

export const responseNotification = (params: ResponseNotificationParams) => apiConfig.patch('api/Notification/response', params);
